import { IModel, Collection } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { ExpressionBasedColumn } from './expression-based.column';
import { IDataFlowDataType } from 'app/model/dataflow/dataflow-datatype';
import { TemplateExpressionBasedColumnBase } from './template-expression-based.column.base';
import { IExpressionBasedEntity } from './IExpressionBasedEntity';
import { DataFlowExpression } from './dataflowexpression';
import { Owned } from 'app/model/base/named';
import { ModelMarkerWrapper } from 'app/shared/utils/model-marker-wrapper';

@Metamodel.model({
    name: 'expressionBasedColumnPattern'
})
export class ExpressionBasedColumnPattern extends TemplateExpressionBasedColumnBase implements IExpressionBasedEntity {
    public static readonly MODEL: IModel;

    public get dataFlowExpression(): DataFlowExpression {
        return this.templateCondition;
    }

    public set dataFlowExpression(expression: DataFlowExpression) {
        this.templateCondition = expression;
    }

    public get entityName(): string {
        return '';
    }

    @Metamodel.attribute({
        type: ExpressionBasedColumn.MODEL,
        collection: Collection.Array,
        constraint: {
            minOccurs: 1
        }
    })
    public columns: ExpressionBasedColumn[] = [];

    public fixedReturnTypeExpression: DataFlowExpression = Owned.create<DataFlowExpression>(DataFlowExpression.MODEL, this);

    public basedColumnDataType?: IDataFlowDataType;

    public markDelete(modelMarkerWrapper: ModelMarkerWrapper): void {
        this.columns.forEach((expressionBasedColumn) => expressionBasedColumn.markDelete(modelMarkerWrapper));
    }
}
